import { Typography } from '@breetometer/components';
import { InfoIcon } from 'BreetAssets';
import { BeneficiaryCard } from 'BreetComponents';
import type { beneficiaryListModeType, IBeneficiary, IBeneficiaryList } from 'BreetHelpers';
import { openModal, useAppDispatch } from 'BreetRedux';
import { useCallback } from 'react';

const BeneficiaryList = ({
	beneficiaries,
	handleBeneficiarySelection,
	selectedBeneficiaryId,
	hideHeader,
	mode = 'select',
	title,
}: IBeneficiaryList) => {
	const dispatch = useAppDispatch();

	const verifyDisabledBeneficiary = useCallback(
		(beneficiary: IBeneficiary, modeArg: beneficiaryListModeType) => () => {
			if (beneficiary.disabled && mode !== 'delete') {
				dispatch(
					openModal({
						id: 'alert',
						metadata: {
							title: 'Bank Unavailable',
							description: 'Oops! Withdrawals to this bank will be available soon. Please try other banks.',
						},
					})
				);
			} else {
				handleBeneficiarySelection(beneficiary, modeArg)();
			}
		},
		[dispatch, handleBeneficiarySelection, mode]
	);

	return (
		<div
			className='beneficiarywrapper'
			data-testid='beneficiary-list'
		>
			{!hideHeader && (
				<div className='beneficiaryheader'>
					<div className={`beneficiaryheadertext${title ? ' title' : ''}`}>
						<Typography
							as='h6'
							className={`color-primary-${title ? '200' : '300'}`}
						>
							{title ?? 'BENEFICIARIES'}
						</Typography>
						{!title && <InfoIcon className='beneficiaryheadertext_infoicon svg-light' />}
					</div>
				</div>
			)}

			<div className={`beneficiarylist scrollbar${(beneficiaries?.length ?? 0) > 1 ? ' multiple' : ''}`}>
				{beneficiaries
					? beneficiaries.map((beneficiary) => (
							<BeneficiaryCard
								name={beneficiary.accountName}
								bankName={beneficiary.bankName}
								accountNumber={beneficiary.accountNumber}
								onClick={verifyDisabledBeneficiary(beneficiary, mode)}
								selected={selectedBeneficiaryId === beneficiary._id}
								isDeleteMode={mode === 'delete'}
								key={beneficiary._id}
								isAutoSettlement={beneficiary.autoSettlement}
								multiple={beneficiaries.length > 1}
								disabled={beneficiary.disabled}
							/>
						))
					: null}
			</div>
		</div>
	);
};

export default BeneficiaryList;
